/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingBulkUploadService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Upload an excel file to create Compliance.Module.Housing.DbModels.HousingApplications in bulk.
     * @param formData
     * @returns number OK
     * @throws ApiError
     */
    public createBulkUpload(
        formData?: {
            file?: Blob;
        },
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingBulkUpload/CreateBulkUpload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
